import { Component, OnDestroy, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ThemeService } from '../_core/services/theme.service';
import { takeUntil } from 'rxjs/operators';
import { Subject, Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { MatchService } from '../_core/services/match.service';
import { HelperService } from '../_core/services/helper.service';
import { App } from '@capacitor/app';
import { throttle } from 'lodash-es';
import { PluginListenerHandle } from '@capacitor/core';

@Component({
    standalone: false,
    selector: 'app-my-matches',
    templateUrl: './my-matches.page.html',
    styleUrls: ['./my-matches.page.scss'],
})
export class MyMatchesPage implements OnInit, OnDestroy {
    currentRoute: string;
    isDarkMode: boolean;
    logo: string;
    isFeaturedEventsShow: boolean = false;
    hideAddEventButton: boolean = true;

    private readonly destroy$: Subject<void> = new Subject();
    private scorekeeperSubscription: Subscription | null = null;
    private throttledScorekeeperAssignment: () => Promise<void>;
    private throttledScorekeeperAssignmentMain: () => Promise<void>;
    private appUrlListener: PluginListenerHandle | null = null;

    constructor(
        public location: Location,
        private themeService: ThemeService,
        public router: Router,
        private matchService: MatchService,
        private helperService: HelperService,
    ) {

        this.throttledScorekeeperAssignment = throttle(async () => {
            const { contextType, contextId, matchTournamentId, matchStatus } = this.helperService.getScorekeeperContext();
            if (contextType && contextId) {
                this.scorekeeperSubscription = await this.helperService.addScorekeeperWithContext(
                    contextId,
                    contextType,
                    matchTournamentId,
                    matchStatus
                );
            }
        }, 3000);
        this.throttledScorekeeperAssignmentMain = throttle(async () => {
            this.handleScorekeeperAssignment();
        }, 3000);
    }

    async ionViewWillEnter() {
        await this.appUrlListener?.remove();
        this.appUrlListener = await App.addListener('appUrlOpen', (state) => {
            if (state.url) {
                this.throttledScorekeeperAssignmentMain();
            }
        });
    }

    async ngOnInit() {
        this.handleRedirectionAfterLogin();
        this.handleScorekeeperAssignment();
        this.isDarkMode = this.themeService.isDarkMode;
        this.logo = this.isDarkMode ? '/assets/img/logo-60-darkmode.png' : '/assets/img/logo-60.png';

        this.themeService
            .subscribeThemeUpdate()
            .pipe(takeUntil(this.destroy$))
            .subscribe(
                (isDarkMode) => {
                    this.logo = isDarkMode ? '/assets/img/logo-60-darkmode.png' : '/assets/img/logo-60.png';
                }
            );

        if (this.router.url === '/featured-events') {
            this.hideAddEventButton = false
        }
    }

    async handleRedirectionAfterLogin() {
        const redirectAfterLogin = localStorage.getItem('redirectAfterLogin');
        if (redirectAfterLogin) {
            localStorage.removeItem('redirectAfterLogin');
            this.router.navigateByUrl(redirectAfterLogin);
        }
    }

    async handleScorekeeperAssignment() {
        // Call the throttled function
        this.throttledScorekeeperAssignment();
    }


    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
        if (this.scorekeeperSubscription) {
            this.scorekeeperSubscription.unsubscribe();
        }
    }

    openAddEventModal() {
        this.router.url.includes('individual')
            ? this.matchService.publishAddEventRequest('individual')
            : this.matchService.publishAddEventRequest('tie');
    }

    canShowUSNationals(): boolean {
        return this.location.isCurrentPathEqualTo('/individual') && new Date().getTime() < new Date('2024-08-12').getTime()
    }

    activeTab(tabName: string) {
        if (tabName === 'featured-events') {
            this.hideAddEventButton = false;
        } else {
            this.hideAddEventButton = true;
        }
    }
}
